/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export var InternalLocale;
(function (InternalLocale) {
    InternalLocale["DANISH"] = "da";
    InternalLocale["GERMAN"] = "du";
    InternalLocale["GREEK"] = "el";
    InternalLocale["ENGLISH"] = "en";
    InternalLocale["SPANISH"] = "es";
    InternalLocale["FINNISH"] = "fi";
    InternalLocale["FRENCH"] = "fr";
    InternalLocale["HUNGARIAN"] = "hu";
    InternalLocale["ITALIAN"] = "it";
    InternalLocale["DUTCH"] = "nl";
    InternalLocale["NORWEGIAN"] = "no";
    InternalLocale["POLISH"] = "pl";
    InternalLocale["PORTUGUESE"] = "pt";
    InternalLocale["ROMANIAN"] = "ro";
    InternalLocale["SWEDISH"] = "sv";
    InternalLocale["CHINESE_SIMPLIFIED"] = "zh_CN";
    InternalLocale["CHINESE_TRADITIONAL"] = "zh_TW";
})(InternalLocale || (InternalLocale = {}));
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export var ISO6391Locale;
(function (ISO6391Locale) {
    ISO6391Locale["DANISH"] = "da";
    ISO6391Locale["GERMAN"] = "de";
    ISO6391Locale["GREEK"] = "el";
    ISO6391Locale["ENGLISH"] = "en";
    ISO6391Locale["SPANISH"] = "es";
    ISO6391Locale["FINNISH"] = "fi";
    ISO6391Locale["FRENCH"] = "fr";
    ISO6391Locale["HUNGARIAN"] = "hu";
    ISO6391Locale["ITALIAN"] = "it";
    ISO6391Locale["DUTCH"] = "nl";
    ISO6391Locale["NORWEGIAN"] = "no";
    ISO6391Locale["POLISH"] = "pl";
    ISO6391Locale["PORTUGUESE"] = "pt";
    ISO6391Locale["ROMANIAN"] = "ro";
    ISO6391Locale["SWEDISH"] = "sv";
    ISO6391Locale["CHINESE_SIMPLIFIED"] = "zh-Hans";
    ISO6391Locale["CHINESE_TRADITIONAL"] = "zh-Hant";
})(ISO6391Locale || (ISO6391Locale = {}));
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export var StripeISO6391Locale;
(function (StripeISO6391Locale) {
    StripeISO6391Locale["DANISH"] = "da";
    StripeISO6391Locale["GERMAN"] = "de";
    StripeISO6391Locale["GREEK"] = "el";
    StripeISO6391Locale["ENGLISH"] = "en";
    StripeISO6391Locale["SPANISH"] = "es";
    StripeISO6391Locale["FINNISH"] = "fi";
    StripeISO6391Locale["FRENCH"] = "fr";
    StripeISO6391Locale["HUNGARIAN"] = "hu";
    StripeISO6391Locale["ITALIAN"] = "it";
    StripeISO6391Locale["DUTCH"] = "nl";
    StripeISO6391Locale["NORWEGIAN"] = "no";
    StripeISO6391Locale["POLISH"] = "pl";
    StripeISO6391Locale["PORTUGUESE"] = "pt";
    StripeISO6391Locale["ROMANIAN"] = "ro";
    StripeISO6391Locale["SWEDISH"] = "sv";
    StripeISO6391Locale["CHINESE_SIMPLIFIED"] = "zh";
    StripeISO6391Locale["CHINESE_TRADITIONAL"] = "zh-TW";
})(StripeISO6391Locale || (StripeISO6391Locale = {}));
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export var LocaleLabel;
(function (LocaleLabel) {
    LocaleLabel["DANISH"] = "Dansk";
    LocaleLabel["GERMAN"] = "Deutsch";
    LocaleLabel["GREEK"] = "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC";
    LocaleLabel["ENGLISH"] = "English";
    LocaleLabel["SPANISH"] = "Espa\u00F1ol";
    LocaleLabel["FINNISH"] = "Suomi";
    LocaleLabel["FRENCH"] = "Fran\u00E7ais";
    LocaleLabel["HUNGARIAN"] = "Magyar";
    LocaleLabel["ITALIAN"] = "Italiano";
    LocaleLabel["DUTCH"] = "Nederlands";
    LocaleLabel["NORWEGIAN"] = "Norsk";
    LocaleLabel["POLISH"] = "Polski";
    LocaleLabel["PORTUGUESE"] = "Portugu\u00EAs";
    LocaleLabel["ROMANIAN"] = "Rom\u00E2n\u0103";
    LocaleLabel["SWEDISH"] = "Svenska";
    LocaleLabel["CHINESE_SIMPLIFIED"] = "\u7B80\u4F53\u4E2D\u6587";
    LocaleLabel["CHINESE_TRADITIONAL"] = "\u7E41\u9AD4\u4E2D\u6587";
})(LocaleLabel || (LocaleLabel = {}));
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const INTERNAL_TO_ISO6391_LOCALES = {
    [InternalLocale.DANISH]: ISO6391Locale.DANISH,
    [InternalLocale.GERMAN]: ISO6391Locale.GERMAN,
    [InternalLocale.GREEK]: ISO6391Locale.GREEK,
    [InternalLocale.ENGLISH]: ISO6391Locale.ENGLISH,
    [InternalLocale.SPANISH]: ISO6391Locale.SPANISH,
    [InternalLocale.FINNISH]: ISO6391Locale.FINNISH,
    [InternalLocale.FRENCH]: ISO6391Locale.FRENCH,
    [InternalLocale.HUNGARIAN]: ISO6391Locale.HUNGARIAN,
    [InternalLocale.ITALIAN]: ISO6391Locale.ITALIAN,
    [InternalLocale.DUTCH]: ISO6391Locale.DUTCH,
    [InternalLocale.NORWEGIAN]: ISO6391Locale.NORWEGIAN,
    [InternalLocale.POLISH]: ISO6391Locale.POLISH,
    [InternalLocale.PORTUGUESE]: ISO6391Locale.PORTUGUESE,
    [InternalLocale.ROMANIAN]: ISO6391Locale.ROMANIAN,
    [InternalLocale.SWEDISH]: ISO6391Locale.SWEDISH,
    [InternalLocale.CHINESE_SIMPLIFIED]: ISO6391Locale.CHINESE_SIMPLIFIED,
    [InternalLocale.CHINESE_TRADITIONAL]: ISO6391Locale.CHINESE_TRADITIONAL,
};
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const ISO6391_TO_INTERNAL_LOCALES = {
    [ISO6391Locale.DANISH]: InternalLocale.DANISH,
    [ISO6391Locale.GERMAN]: InternalLocale.GERMAN,
    [ISO6391Locale.GREEK]: InternalLocale.GREEK,
    [ISO6391Locale.ENGLISH]: InternalLocale.ENGLISH,
    [ISO6391Locale.SPANISH]: InternalLocale.SPANISH,
    [ISO6391Locale.FINNISH]: InternalLocale.FINNISH,
    [ISO6391Locale.FRENCH]: InternalLocale.FRENCH,
    [ISO6391Locale.HUNGARIAN]: InternalLocale.HUNGARIAN,
    [ISO6391Locale.ITALIAN]: InternalLocale.ITALIAN,
    [ISO6391Locale.DUTCH]: InternalLocale.DUTCH,
    [ISO6391Locale.NORWEGIAN]: InternalLocale.NORWEGIAN,
    [ISO6391Locale.POLISH]: InternalLocale.POLISH,
    [ISO6391Locale.PORTUGUESE]: InternalLocale.PORTUGUESE,
    [ISO6391Locale.ROMANIAN]: InternalLocale.ROMANIAN,
    [ISO6391Locale.SWEDISH]: InternalLocale.SWEDISH,
    [ISO6391Locale.CHINESE_SIMPLIFIED]: InternalLocale.CHINESE_SIMPLIFIED,
    [ISO6391Locale.CHINESE_TRADITIONAL]: InternalLocale.CHINESE_TRADITIONAL,
};
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const INTERNAL_TO_STRIPE_LOCALES = {
    [InternalLocale.DANISH]: StripeISO6391Locale.DANISH,
    [InternalLocale.GERMAN]: StripeISO6391Locale.GERMAN,
    [InternalLocale.GREEK]: StripeISO6391Locale.GREEK,
    [InternalLocale.ENGLISH]: StripeISO6391Locale.ENGLISH,
    [InternalLocale.SPANISH]: StripeISO6391Locale.SPANISH,
    [InternalLocale.FINNISH]: StripeISO6391Locale.FINNISH,
    [InternalLocale.FRENCH]: StripeISO6391Locale.FRENCH,
    [InternalLocale.HUNGARIAN]: StripeISO6391Locale.HUNGARIAN,
    [InternalLocale.ITALIAN]: StripeISO6391Locale.ITALIAN,
    [InternalLocale.DUTCH]: StripeISO6391Locale.DUTCH,
    [InternalLocale.NORWEGIAN]: StripeISO6391Locale.NORWEGIAN,
    [InternalLocale.POLISH]: StripeISO6391Locale.POLISH,
    [InternalLocale.PORTUGUESE]: StripeISO6391Locale.PORTUGUESE,
    [InternalLocale.ROMANIAN]: StripeISO6391Locale.ROMANIAN,
    [InternalLocale.SWEDISH]: StripeISO6391Locale.SWEDISH,
    [InternalLocale.CHINESE_SIMPLIFIED]: StripeISO6391Locale.CHINESE_SIMPLIFIED,
    [InternalLocale.CHINESE_TRADITIONAL]: StripeISO6391Locale.CHINESE_TRADITIONAL,
};
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const ISO6391_LOCALES_TO_LABELS = {
    [ISO6391Locale.DANISH]: LocaleLabel.DANISH,
    [ISO6391Locale.GERMAN]: LocaleLabel.GERMAN,
    [ISO6391Locale.GREEK]: LocaleLabel.GREEK,
    [ISO6391Locale.ENGLISH]: LocaleLabel.ENGLISH,
    [ISO6391Locale.SPANISH]: LocaleLabel.SPANISH,
    [ISO6391Locale.FINNISH]: LocaleLabel.FINNISH,
    [ISO6391Locale.FRENCH]: LocaleLabel.FRENCH,
    [ISO6391Locale.HUNGARIAN]: LocaleLabel.HUNGARIAN,
    [ISO6391Locale.ITALIAN]: LocaleLabel.ITALIAN,
    [ISO6391Locale.DUTCH]: LocaleLabel.DUTCH,
    [ISO6391Locale.NORWEGIAN]: LocaleLabel.NORWEGIAN,
    [ISO6391Locale.POLISH]: LocaleLabel.POLISH,
    [ISO6391Locale.PORTUGUESE]: LocaleLabel.PORTUGUESE,
    [ISO6391Locale.ROMANIAN]: LocaleLabel.ROMANIAN,
    [ISO6391Locale.SWEDISH]: LocaleLabel.SWEDISH,
    [ISO6391Locale.CHINESE_SIMPLIFIED]: LocaleLabel.CHINESE_SIMPLIFIED,
    [ISO6391Locale.CHINESE_TRADITIONAL]: LocaleLabel.CHINESE_TRADITIONAL,
};
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const isInternalLocale = (locale) => Object.values(InternalLocale).some((cwLocale) => cwLocale === locale);
/**
 * @ignore
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
const getLocale = (locale, source) => {
    if (!isInternalLocale(locale)) {
        return null;
    }
    return source[locale];
};
/**
 * Transforms Catawiki internal into ISO6391 code format. Returns null if the
 * input parameter does not represent CW locale code. Case-sensitive.
 *
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const getISO6391Locale = (locale) => getLocale(locale, INTERNAL_TO_ISO6391_LOCALES);
/**
 * Transforms Catawiki internal into ISO6391 code format for Stripe. Returns null if the
 * input parameter does not represent CW locale code. Case-sensitive.
 *
 * @see https://stripe.com/docs/js/appendix/supported_locales
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const getStripeISO6391Locale = (locale) => getLocale(locale, INTERNAL_TO_STRIPE_LOCALES);
/**
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const isISO6391Locale = (locale) => Object.values(ISO6391Locale).some((l) => l === locale);
/**
 * Transforms ISO6391 code into Catawiki internal format. Returns null if the
 * input parameter does not represent ISO6391 locale code. Case-sensitive.
 *
 * @deprecated This module is deprecated. Please use the `@catawiki/locale` package instead.
 */
export const getInternalLocaleFromISO6391Locale = (locale) => {
    if (!isISO6391Locale(locale)) {
        return null;
    }
    return ISO6391_TO_INTERNAL_LOCALES[locale];
};
